export default "__VITE_ASSET__C0_0W76X__"